import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const QuantityInput = ({ initialCount = 1, min, max = 100, label, price, required, onChange }) => {
    const [count, setCount] = useState(initialCount);

    useEffect(() => {
        setCount(initialCount);
    }, [initialCount]);

    const increment = () => {
        if (count < max) {
            const newCount = count + 1;
            setCount(newCount);
            if (onChange) {
                onChange(newCount);
            }
        }
    };

    const decrement = () => {
        if (count > min) {
            const newCount = count - 1;
            setCount(newCount);
            if (onChange) {
                onChange(newCount);
            }
        }
    };

    return (
        <label className={`flex flex-col gap-1 w-full`}>
            {label && (
            <div>
                <span className="text-sportsBlack font-medium text-base leading-[26px] mb-1">
                    {label + " "}
                </span>
                {price && (
                <span className="text-sportsDarkGrey font-medium text-base leading-[26px] mb-1">
                    {price}
                </span>
                )}
                {required && "*"}
            </div>
            )}
            <div className="flex items-center w-full border border-[#E3E3E3] bg-[#F8F8F8] rounded-[4px] p-3">
                <div className={` transition-all ease-in-out cursor-pointer rounded `}>
                    <button 
                        onClick={decrement} 
                        disabled={count <= min} 
                        className={`p-[15px] text-sportsDarkGrey ${count !== 1 ? 'bg-sportsYellow' : ''}`}
                    >
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13 8H3" stroke={`${count === 0 ? '#727272' : '#000'}`} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>
                </div>
                <span className="mx-2 text-sportsBlack flex-grow text-center">{count}</span>
                <div className={`transition-all ease-in-out cursor-pointer rounded`}>
                    <button 
                        onClick={increment} 
                        disabled={count >= max} 
                        className={`${count !== max ? 'bg-sportsYellow' : ''} p-[15px] text-sportsDarkGrey `}
                    >
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8 3V13M13 8H3" stroke={`${count === max ? '#727272' : '#000'}`} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>
                </div>
            </div>
        </label>
    );
};

QuantityInput.propTypes = {
    label: PropTypes.string,
    price: PropTypes.string,
    initialCount: PropTypes.number,
    min: PropTypes.number,
    max: PropTypes.number,
    required: PropTypes.bool,
    onChange: PropTypes.func,
};

export default QuantityInput;